module.exports = __webpack_public_path__ + "img/elastic width.6d10c837.png";